<template>
    <v-container grid-list-xs>
        <v-row>
            <v-col>
                <v-sheet class="pa-5 sheet center" elevation="3">
                    <PageHeader>
                        <template #header>
                            <h4>Loading</h4>
                        </template>
                    </PageHeader>
                    <div class="loading-wrapper">
                        <Loader />
                    </div>
                </v-sheet>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import StartFlowAction from "@/action/actions/StartFlowAction"
    import { workflowService, iovationService, googleAnalyticsService } from "@/service"
    import { providerState } from "@/state"

    export default {
        async created() {
            // workflowService will handle any exceptions
            await workflowService.invoke(new StartFlowAction(this.$route))
            try {
                googleAnalyticsService.setUpGoogleAnalytics()
            } catch (e) {
                console.log("Error adding custom scripts", e)
            }

            const properties = providerState?.getAllProviderProperties()
            const isIovationEnabled = Object.values(properties).some(value => {
                return value.iovationEnabled
            })
            if (isIovationEnabled) {
                await iovationService.load()
            }
        },
    }
</script>

<style lang="scss" scoped>
    .loading-wrapper {
        height: 50vh;
        margin-top: 130px;
    }
</style>
